module.exports = __webpack_public_path__ + "img/redgold.754b4bb.webp";